import { changePodlokotniki } from "./changePodlokotniki";

export const updateGazliftDependencies = () => {
    if (servObj.activePodlokotniki.length) {
        changePodlokotniki(true);
    }
};
